<template>
  <div style="opacity: .25;">
    <div class="grid-x grid-padding-x">
      <!--
      <div class="cell shrink">
        <div class="chart-detail">
          <div>Revenue</div>
          <h4>$12.34</h4>
        </div>
      </div>

      <div class="cell shrink">
        <div class="chart-detail">
          <div>Orders</div>
          <h4>{{ orderCount }}</h4>
        </div>
      </div>

      <div class="cell shrink">
        <div class="chart-detail">
          <div>Vendors</div>
          <h4>121</h4>
        </div>
      </div>
      -->

      <div class="cell auto">
        Infographs Coming soon...
      </div>

      <div class="cell shrink">
        <div class="select-field">
          <select>
            <option>Last 7 days</option>
          </select>

          <i class="fas fa-sort"></i>
        </div>
      </div>
    </div>

    <canvas id="chart" class="chart"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js'

export default {
  mounted () {
    let ctx = document.getElementById('chart').getContext('2d')

    Chart.defaults.global.defaultFontColor = '#ffffff'

    // eslint-disable-next-line
    new Chart(ctx, {
      type: 'line',
      data: {
        labels: ['1', '2', '3', '4', '5', '6', '7'],
        datasets: [
          {
            label: '',
            data: [12, 19, 3, 5, 2, 3, 8],
            borderColor: [
              '#eb008c'
            ],
            borderWidth: 2,
            tension: 0.00000001
          }
        ]
      },
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
    })
  }
}
</script>

<style lang="scss">
@import '../../../styles/mixins';
@import '../../../styles/variables';
</style>



// WEBPACK FOOTER //
// src/pages/vendors/sections/chart.vue